//const config = { apiUrl:'http://horizoncongreso.bounceme.net:3030/'}
//const config = { apiUrl:'http://localhost:57314/'}
//const config = { apiUrl:'http://192.168.0.210:3030/'}
//const config = { apiUrl:'http://192.168.0.210:750/interap_pagos/'}
//const config = { apiUrl:'http://201.140.99.157:3030/'}
const config = { apiUrl:'https://horizonpagos.com.mx/interap_pagos'}
export default config